import { combineReducers } from "@reduxjs/toolkit";
import { LoginData } from "./Login/reducer";
import { userData } from "./User/reducer";
import { CategoriesData } from "./Categories/reducer";
import { ProductsData } from "./Products/reducer";
import { CartData } from "./Mycart/reducer";

export default combineReducers({ LoginData, userData, CategoriesData, ProductsData ,CartData});
